import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormControlErrorsModule, LayoutModule, SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import { NgxPrintModule } from 'ngx-print';
import { StockOrderViewModalComponent } from './picking-stock-order-query/stock-order-view-modal.component';
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import { RouterModule, Routes } from '@angular/router';
import { PickingDashboardSerialNumberPoupComponent, PickingDashboardViewComponent } from './picking-dashboard-view';
import { StockOrderQueryAddEditComponent, StockOrderQueryResubmitComponent, StockOrderQueryViewComponent } from './picking-stock-order-query';
import { PickingDashboardOrdersComponentNew } from './picking-dashboard-orders-new.component';

const routes: Routes = [
  { path: '', component: PickingDashboardOrdersComponentNew, data: { title: 'Picking Dashboard Orders' },canActivate:[AuthGuard] },
  { path: 'picking-dashboard-view', component: PickingDashboardViewComponent, data: { title: 'Picking Dashboard View' },canActivate:[AuthGuard] },
  { path: 'stock-order-add-edit', component: StockOrderQueryAddEditComponent, data: { title: 'Stock Order Query Add Edit' },canActivate:[AuthGuard] },
  { path: 'stock-order-view', component: StockOrderQueryViewComponent, data: { title: 'Stock Order Query View' },canActivate:[AuthGuard] },
  { path: 'stock-order-resubmit', component: StockOrderQueryResubmitComponent, data: { title: 'Stock Order Query' },canActivate:[AuthGuard] },
];

const declarationComponents = [
  PickingDashboardOrdersComponentNew,
  PickingDashboardViewComponent,
  StockOrderQueryAddEditComponent,
  StockOrderQueryViewComponent,
  StockOrderQueryResubmitComponent,
  StockOrderViewModalComponent,
  PickingDashboardSerialNumberPoupComponent
];
@NgModule({
  declarations: [
    ...declarationComponents
  ],
  imports: [
    CommonModule,
    NgxPrintModule,
    LayoutModule,
    MaterialModule,
    SharedModule,
    FormControlErrorsModule,
    RouterModule.forChild(routes)
  ],
  entryComponents: [
    StockOrderViewModalComponent,
    PickingDashboardSerialNumberPoupComponent
  ]
})
export class PickingDashboardOrdersModule { }